import React, { useEffect, useState } from 'react';
import { Button, NotFoundState } from '@rio-cloud/rio-uikit';
import { FormattedMessage } from 'react-intl';
import CampaignTargetVehiclesForm from '~/features/campaigns/components/campaignForm/CampaignTargetVehiclesForm';
import { useForm } from 'react-hook-form';
import { useEditStageMutation } from '~/api/stages/Stages.api';

interface StageSetupProps {
    stageId: number;
    onStageSetup: () => void;
}

const StageSetup: React.FC<StageSetupProps> = ({ stageId, onStageSetup }) => {
    const [showForm, setShowForm] = useState(false);

    useEffect(() => {
        if (stageId) {
            setShowForm(false);
        }
    }, [stageId]);
    const { control, setValue, handleSubmit, watch } = useForm();
    const [editStage, { isLoading: isSubmitting }] = useEditStageMutation();

    const selectedGroup = watch('targetGroups');

    const handleAssignVehicles = () => {
        setShowForm(true);
    };

    const onSubmit = async(formData: any) => {
        if (!formData.targetGroups) {
            return;
        }
        try {
            await editStage({
                id: stageId,
                vehicleGroup: formData.targetGroups,
            }).unwrap().then(() => onStageSetup());

            setShowForm(false);
        } catch (error) {
            console.error('Error assigning vehicles:', error);
        }
    };

    if (showForm) {
        return (
            <div className='border border-color-light border-radius-5 padding-25'>
                <CampaignTargetVehiclesForm
                    control={control}
                    setValue={setValue}
                />
                <div className='margin-top-20 display-flex justify-content-end'>
                    <Button
                        onClick={() => setShowForm(false)}
                        className='margin-right-10'
                    >
                        <FormattedMessage id='intl-msg:cancel'/>
                    </Button>
                    <Button
                        onClick={handleSubmit(onSubmit)}
                        disabled={isSubmitting || !selectedGroup}
                    >
                        <FormattedMessage id='intl-msg:save'/>
                    </Button>
                </div>
            </div>
        );
    }

    return (
        <NotFoundState
            fullWidth
            headline={<FormattedMessage id='intl-msg:stage:noDevicesAssigned'/>}
            message={<FormattedMessage id='intl-msg:stage:noDevicesAssigned:message'/>}
            buttons={[{ text: <FormattedMessage id='intl-msg:stage:assignDevices'/>, onClick: handleAssignVehicles }]}
        />
    );
};

export default StageSetup;
